import React from "react";
import { Typography } from "@material-ui/core";

export const mentoringAvailabilitySchema = {
  title: "Mentoring Availability",
  logicalname: "Contact",
  type: "object",
  description:
    "Are you looking to share your knowledge, experience, and help guide someone to a successful career?",
  additionalDescription: () => (
    <>
      <Typography component="span" style={{ fontWeight: 700 }}>Important</Typography>: To be matched with mentees, you must complete both the <Typography component="span" style={{ fontWeight: 700 }}>Topics</Typography> tab and your <Typography component="span" style={{ fontWeight: 700 }}>Availability</Typography> below. Profiles with incomplete information will not be considered for matching.
    </>
  ),
  required: [
    "ctpt_optedintosaiceconnect",
    "ctpt_availabledaytime",
    "ctpt_availableevenings",
    "ctpt_availableonweekdays",
    "ctpt_availableonweekends",
  ],
  properties: {
    ctpt_optedintosaiceconnect: {
      title: "Do you wish to use SAICE Connect?",
      type: "string",
      schemaname: "ctpt_optedintosaiceconnect",
      datatype: "string",
      requiredCheck: true,
      // NOTE: These enum values are placeholders. You need to check your CRM 
      // to get the actual option set values for this Choice field.
      // In Dataverse/Power Platform, Choice fields typically use numeric values like "533910000", "533910001"
      // You can find these values in the CRM by checking the field's option set values
      enum: ["533910000", "533910001"], // TODO: Replace with actual CRM option set values
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only valid values are selected
    },
    ctpt_connectmentor: {
      title: "Are you available to provide mentoring services, to Mentees?",
      type: "string",
      schemaname: "ctpt_connectmentor",
      datatype: "string",
      requiredCheck: false,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Optional field - enum constraint ensures only True/False values are selected
    },
    ctpt_availabledaytime: {
      title: "Available Daytime",
      type: "string",
      schemaname: "ctpt_availabledaytime",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableevenings: {
      title: "Available Evenings",
      type: "string",
      schemaname: "ctpt_availableevenings",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableonweekdays: {
      title: "Available On Weekdays",
      type: "string",
      schemaname: "ctpt_availableonweekdays",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availableonweekends: {
      title: "Available On Weekends",
      type: "string",
      schemaname: "ctpt_availableonweekends",
      datatype: "string",
      requiredCheck: true,
      enum: ["True", "False"],
      enumNames: ["Yes", "No"],
      // Validation: Required field - enum constraint ensures only True/False values are selected
    },
    ctpt_availabilitynotes: {
      title: "Availability Notes",
      type: "string",
      schemaname: "ctpt_availabilitynotes",
      datatype: "string",
      requiredCheck: false,
      // Pattern validation: allows empty string OR string that doesn't start with space
      // This prevents the validation error from showing on initial load when field is empty
      pattern: '^$|^[^ ].*$',
      message: "Text cannot start with a space. Please remove leading spaces.",
      minLength: 0,
      maxLength: 1000,
      // Validation rules:
      // - Optional field (can be empty)
      // - If provided, cannot start with a space
      // - Maximum 1000 characters allowed
    },
  },
};

